/**
 * Helpers
 */
import { onVisibilityChange } from './helpers'

/**
 * Web standards
 */
import './menu'
import './lazyload'
import './cookieconsent'

/**
 * Scripts which doesn't need dynamic import
 */
import {  Modal } from 'bootstrap';

/**
 * Dynamic import scripts
 */
const elements = [
  '.aos-element',
  '.screen__column',
  '[data-has-swiper="true"]',
  '.swiper',
  '.blog'
];

[].forEach.call(elements, (element) => {


  if (document.querySelector(element) !== null && document.querySelector(element) !== undefined) {

    const lazyloadHandler = onVisibilityChange(document.querySelector(element), function () {

      // Example library without init:
      if (element === '.screen__column') {
        const Filters = import('./screens')
      }

      // Example library with init:
      if (element === '[data-aos]' || element === '.aos-element') {
        const AOS = import('aos').then(AOS => {
          AOS.init({
            disable: function() {
              return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
            }
          });
        });
      }

      if (element === '[data-has-swiper="true"]') {
        const Swipers = import('./swipers')
      }

      if ( element === '.swiper' ) {
        const SwiperCSS = import( 'swiper/css' );
        // const SwiperCSSNavigation = import( 'swiper/css/navigation' );
        const SwiperCSSPagination = import( 'swiper/css/pagination' );
      }

      if ( element === '.blog' ) {
        const BlogsJS = import( './blogs' );
      }
    })

    if (window.addEventListener) {
      addEventListener('DOMContentLoaded', lazyloadHandler, false);
      addEventListener('load', lazyloadHandler, false);
      addEventListener('scroll', lazyloadHandler, false);
      addEventListener('resize', lazyloadHandler, false);
    } else if (window.attachEvent) {
      attachEvent('onDOMContentLoaded', lazyloadHandler); // Internet Explorer 9+ :(
      attachEvent('onload', lazyloadHandler);
      attachEvent('onscroll', lazyloadHandler);
      attachEvent('onresize', lazyloadHandler);
    }
  }
});
